import { useEffect, useRef } from 'react'

export default useComponentIsMountedRef = ->
  isMounted = useRef(undefined)

  useEffect( ->
    isMounted.current = true
    -> isMounted.current = false
  , [])

  isMounted